import SubscriptionActions from '../actions/SubscriptionActions';
import Url from '../constants/Url';
import axios from 'axios';
import root from 'window-or-global';

/**
 * SubscriptionSource
 *
 */

const SubscriptionSource = {
    getStatus: {
        remote(state, email) {
            return axios.get(Url().SUBSCRIPTION.GET_STATUS, {
                params: {
                email
            }
            });
        },
        success: SubscriptionActions.getStatusSuccess,
        error: SubscriptionActions.getStatusFailure,
        shouldFetch() {
            return !root.__server_side_render;
        }
    },
    subscribe: {
        remote(state, email) {
            return axios.post(Url().SUBSCRIPTION.ADD, {
                email
            });
        },
        success: SubscriptionActions.subscribeSuccess,
        error: SubscriptionActions.subscribeFailure,
        shouldFetch() {
            return !root.__server_side_render;
        }
    },
    getOptOutLink: {
        remote() {
            return axios.get(Url().SUBSCRIPTION.OPTOUTLINK)
        },
        success: SubscriptionActions.getOptOutLinkSuccess,
        error: SubscriptionActions.getOptOutLinkFailure,
        shouldFetch() {
            return !root.__server_side_render;
        }
    }
};

export default SubscriptionSource;
